import { useContext, useMemo } from 'react';
import { BaseEdge, useNodes } from '@xyflow/react';
import WorkflowContext from '../../Workflow/WorkflowContext';

export default function SelfConnectingEdge(props) {
  const {
    id, source, target, sourceX, sourceY, targetX, targetY,
    label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius,
    interactionWidth, className, markerStart,
  } = props;

  const nodes = useNodes();
  const { state } = useContext(WorkflowContext);

  const stroke = useMemo(() => {
    return state?.steps?.[target]?.color || 'gray';
  }, [state, target]);

  const sourceNode = nodes.find(node => node.id === source);

  const radiusX = useMemo(() => (sourceX - targetX) * 0.6, [sourceX, targetX]);
  const radiusY = useMemo(() => {
    if (sourceNode?.data?.stepdef?.type === 'branch') {
      // Currently hard-coding this for desicion nodes as they are constant height/width
      return 70;
    }

    return sourceNode.height / 1.8;
  }, [nodes]);

  const edgePath = useMemo(() => `M ${sourceX - 5} ${sourceY} A ${radiusX} ${radiusY} 0 1 1 ${targetX + 2} ${targetY}`, [
    sourceX,
    sourceY,
    radiusX,
    targetX,
    targetY,
  ]);

  const labelX = useMemo(() => {
    return (sourceX + targetX) / 2;
  }, [sourceX, targetX]);

  const labelY = useMemo(() => {
    return sourceY + radiusY * 1.58;
  }, [sourceY]);

  return (
    <>
      <svg style={{ position: 'absolute', top: 0, left: 0 }}>
        <defs>
          <marker id={`edge-marker-${id}`} viewBox="-10 -10 20 20" markerHeight={20} markerWidth={20} refX={0} refY={0}>
            <polyline stroke={stroke} fill={stroke} strokeWidth={1} strokeLinecap="round" strokeLinejoin="round" points="-5,-4 0,0 -5,4 -5,-4" />
          </marker>
        </defs>
      </svg>
      <BaseEdge
        id={id}
        path={edgePath}
        labelX={labelX}
        labelY={labelY}
        label={label}
        labelStyle={labelStyle}
        labelShowBg={labelShowBg}
        labelBgStyle={labelBgStyle}
        labelBgPadding={labelBgPadding}
        labelBgBorderRadius={labelBgBorderRadius}
        interactionWidth={interactionWidth}
        className={className}
        markerStart={markerStart}
        style={{ stroke }}
        markerEnd={`url(#edge-marker-${id})`}
      />
    </>
  );
}
